/**
 * PortalSAMLErrorPage — traduce el motivo por el que el SSO del portal no dejó entrar.
 *
 * Ruta: /colaboradores/saml-error?code=<motivo>
 *
 * Los mensajes evitan revelar si un email existe o no en la nómina: quien intenta
 * entrar sin ser trabajador recibe lo mismo que quien tiene la ficha inactiva.
 */
import { Link, useSearchParams } from 'react-router-dom'
import { ShieldAlert } from 'lucide-react'
import { EnvBanner } from '@/components/EnvBanner'

const MENSAJES: Record<string, string> = {
  portal_sso_no_employee:
    'Tu cuenta corporativa no está asociada a una ficha de trabajador activa. Contacta al área de RRHH.',
  portal_sso_employee_inactive:
    'Tu cuenta corporativa no está asociada a una ficha de trabajador activa. Contacta al área de RRHH.',
  portal_sso_account_disabled:
    'Tu acceso al portal está deshabilitado. Contacta al área de RRHH.',
  portal_sso_disabled:
    'El ingreso con SSO no está habilitado para esta empresa.',
  missing_token: 'El enlace de acceso no es válido. Vuelve a intentarlo.',
  callback_failed: 'La sesión expiró antes de completarse. Vuelve a intentarlo.',
}

export default function PortalSAMLErrorPage() {
  const [searchParams] = useSearchParams()
  const code = searchParams.get('code') || ''
  const mensaje = MENSAJES[code] || 'No se pudo completar el ingreso con SSO.'

  return (
    <div className="min-h-screen bg-canvas flex flex-col">
      <EnvBanner />
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-sm text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-danger/10">
            <ShieldAlert size={24} className="text-danger" />
          </div>
          <h1 className="text-lg font-semibold text-content">No pudimos iniciar tu sesión</h1>
          <p className="mt-2 text-sm text-content-muted">{mensaje}</p>
          <Link
            to="/colaboradores/login"
            className="mt-6 inline-block rounded-lg bg-primary px-4 py-2 text-sm font-medium
                       text-on-primary transition-colors hover:bg-primary-hover"
          >
            Volver a intentar
          </Link>
        </div>
      </div>
    </div>
  )
}
